import { PopoverFailedComponent } from '@1bill-app/components/popover-failed/popover-failed.component';
import { isBillOverdue, isBillPaid } from '@1bill-app/services/bill/helper';
import {
  appProductTypeDefaultImg,
  appProductTypes,
  ViewBillType,
} from '@1bill-app/services/bill/types';
import { Job } from '@1bill-app/services/status/types';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { BillService } from '@1bill-app/services/bill/bill.service';
import { CategoryService } from '@1bill-app/services/category/category.service';

@Component({
  selector: 'app-bill-block-single',
  styleUrls: ['./bill-block-single.component.scss'],
  templateUrl: './bill-block-single.component.html',
})
export class BillBlockSingleComponent implements OnInit {
  @Input() bill: ViewBillType;
  @Input() job: Job;
  @Input() dummy: boolean = false;
  @Output() cardClick: EventEmitter<{
    billPaymentId?: number;
    jobId?: number;
  }> = new EventEmitter();
  @Output() payNowClick: EventEmitter<{ billPaymentId: number }> = new EventEmitter();
  isBeingPaid: boolean = false;
  public isBillPaid = isBillPaid;
  public isBillOverdue = isBillOverdue;
  get jobBillInfo() {
    let barcode = this.job?.barcode?.find((b) => b?.billInfo?.billerName != null)?.billInfo;
    if (!barcode) barcode = this.job?.barcode?.find((b) => b?.billInfo != null)?.billInfo;
    return barcode;
  }

  constructor(
    private logger: NGXLogger,
    private datePipe: DatePipe,
    private popoverController: PopoverController,
    private billService: BillService,
    private categoryService: CategoryService,
  ) {}

  ngOnInit() {
    this.billService.billPayingEvent$.subscribe((payingBillIds: number[]) => {
      this.isBeingPaid = payingBillIds?.includes(this.bill?.billPaymentId);
    });
  }
  
  getCardIconUrl(bill: ViewBillType) {
    return this.categoryService.getCardIconUrl(bill);
  }

  onPayNowClick(billPaymentId: number) {
    this.logger.debug('onPayNowClick()');
    this.payNowClick.emit({ billPaymentId });
  }
  async onReadMoreClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const popover = await this.popoverController.create({
      component: PopoverFailedComponent,
      cssClass: 'my-custom-class',
      // event: ev,
      translucent: true,
    });
    return await popover.present();
  }
  onCardClick() {
    if (!this.bill.billPaymentId) this.cardClick.emit({ jobId: this.bill.jobId });
    else this.cardClick.emit({ billPaymentId: this.bill.billPaymentId });
  }
  isFailedBill() {
    return !this.bill?.billPaymentId;
  }
  isSucceededBill() {
    return this.bill.billPaymentId;
  }
  getBillDueDate(bill: ViewBillType) {
    const dateFormat = 'dd MMM y';
    return isBillPaid(bill)
      ? bill.datePaid
        ? this.datePipe.transform(bill.datePaid, dateFormat)
        : '-'
      : bill.dueDate
      ? this.datePipe.transform(bill.dueDate, dateFormat)
      : '-';
  }
}
